export default "__VITE_ASSET__CSp6CwBV__"